import React from 'react';
import Styled from './styled';

import { ChatIcon, CloseIcon } from '../Icon';

export type WidgetIconProps = {
    onClick: () => void;
    // indicates whether the widget icon is opened or closed
    isOpen?: boolean;
    // accessibility support (alt text/aria-label)
    ariaLabel?: string;
};

/**
 * WidgetIcon component that displays either a chat bubble or a close icon with a 3D flip animation.
 * 
 * @param {WidgetIconProps} props - The properties to configure the WidgetIcon component.
 * @returns {JSX.Element} The rendered WidgetIcon component.
 */
export const WidgetIcon: React.FC<WidgetIconProps> = ({
    onClick,
    isOpen = false,
    ariaLabel,
}) => {
    return (
        <Styled.IconContainer
            onClick={onClick}
            isOpen={isOpen}
            aria-label={ariaLabel}
            role="button"
            tabIndex={0}
            onKeyDown={(event: { key: string; }) => {
                //clicking enter should act as clicking the icon
                if (event.key == 'Enter') {
                    onClick && onClick();
                }
            }}
        >
            <Styled.IconFlipper isOpen={isOpen}>
                <Styled.IconFace className='front'>
                    <ChatIcon />
                </Styled.IconFace>
                <Styled.IconFace className='back'>
                    <CloseIcon />
                </Styled.IconFace>
            </Styled.IconFlipper>
        </Styled.IconContainer>
    );
};
